import moment from 'moment';
import { FC } from 'react';

import { OkrActivityI } from '~src/interfaces/okrActivity.interface';
import { SegmentType } from '~src/interfaces/segment.interface';
import { translateContent } from '~src/services/translationServices';
import AvatarBox from '~src/shared/avatarBox/AvatarBox';

import { ActivityBody, ActivityDate, ActivityText, ActivityWrapper } from './activityElement.sc';

interface Props {
  activity: OkrActivityI;
}

const ActivityElement: FC<Props> = props => {
  const { user_img, sentence, created_at, username } = props.activity;
  // !Important the sentence is translated with the content locale NOT with the system language
  return (
    <ActivityWrapper>
      <AvatarBox name={username} type={SegmentType.User} size={25} url={user_img} />
      <ActivityBody>
        <ActivityText>{translateContent(sentence)}</ActivityText>
        <ActivityDate>{moment(created_at).format('LLL')}</ActivityDate>
      </ActivityBody>
    </ActivityWrapper>
  );
};

export default ActivityElement;
